import styles from './Onboarding.module.css'

const TOTAL_STEPS = 2

// Brand row + step progress at the top of every funnel screen (v2 design,
// approved 2-screen mock). Register renders it on the last slot too — for
// guests, registration is the funnel's follow-on from the topics screen.
// `role` overrides the default caption for the break_up segment (mattermost
// 27.10: «ИИ-сопровождение в расставаниях» everywhere the brand shows).
export default function OnboardingBrand({ step, role = 'AI-психолог' }: { step: number; role?: string }) {
  return (
    <div className={styles.brand}>
      <img className={styles.logo} src="/assets/app-icon.png" alt="" width={36} height={36} />
      <div className={styles.brandText}>
        <div className={styles.brandName}>Хьюмантек</div>
        <div className={styles.brandRole}>{role}</div>
      </div>
      <div className={styles.progress}>
        <span className={styles.stepCount}>
          {step} из {TOTAL_STEPS}
        </span>
        <span className={styles.dots} aria-hidden="true">
          {Array.from({ length: TOTAL_STEPS }).map((_, i) => (
            <span key={i} className={i < step ? styles.dotOn : styles.dot} />
          ))}
        </span>
      </div>
    </div>
  )
}
